/** Fiche machine, ses caractéristiques, son historique, ses notices et son étiquette QR. */
import { lazy } from 'react';
import type { AppRoute, RouteGate } from '../../app/route-types.js';

const EquipmentDetail = lazy(() => import('./EquipmentDetail.js').then((m) => ({ default: m.EquipmentDetail })));
const EquipmentEditPage = lazy(() => import('./EquipmentForms.js').then((m) => ({ default: m.EquipmentEditPage })));
const EquipmentHistoryNewPage = lazy(() => import('./EquipmentForms.js').then((m) => ({ default: m.EquipmentHistoryNewPage })));
const EquipmentNoticeNewPage = lazy(() => import('./EquipmentForms.js').then((m) => ({ default: m.EquipmentNoticeNewPage })));
const EquipmentLifecyclePage = lazy(() => import('./EquipmentLifecycle.js').then((m) => ({ default: m.EquipmentLifecyclePage })));
const EquipmentMovePage = lazy(() => import('./EquipmentLifecycle.js').then((m) => ({ default: m.EquipmentMovePage })));
const QrLabelPage = lazy(() => import('./QrLabelPage.js').then((m) => ({ default: m.QrLabelPage })));
const EquipmentVideoNewPage = lazy(() => import('./EquipmentVideoNewPage.js').then((m) => ({ default: m.EquipmentVideoNewPage })));

/** Lire une machine : fiche client ou historique des machines (l'API précise par site). */
const read: RouteGate = { anyOf: ['customer.view', 'equipment.history.view'] };
const manage: RouteGate = { ...read, allOf: ['equipment.manage'] };
const addHistory: RouteGate = { ...read, allOf: ['equipment.history.add_official'] };

export const equipmentRoutes: AppRoute[] = [
  { path: '/equipements/:id', element: <EquipmentDetail />, gate: read },
  { path: '/equipements/:id/modifier', element: <EquipmentEditPage />, gate: manage },
  { path: '/equipements/:id/historique/nouveau', element: <EquipmentHistoryNewPage />, gate: addHistory },
  { path: '/equipements/:id/notices/nouvelle', element: <EquipmentNoticeNewPage />, gate: manage },
  { path: '/equipements/:id/videos/nouvelle', element: <EquipmentVideoNewPage />, gate: manage },
  { path: '/equipements/:id/statut/:action', element: <EquipmentLifecyclePage />, gate: manage },
  { path: '/equipements/:id/deplacer', element: <EquipmentMovePage />, gate: manage },
  { path: '/equipements/:id/etiquette', element: <QrLabelPage />, gate: read },
];
